import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import './transition.css';

// Types
import mixins from "vue-typed-mixins"; // Mixins
import sectionView from '../../mixins/sectionView';
import sectionMapper from '../../sectionMapper';
import PageWithSections from '../../mixins/PageWithSections';
import { WithRefs } from '../../utils/withRefs';
import SeoHelper from '../../mixins/SeoHelper';

// Components
import { PostView } from '../overridableComponents';

// Enums
import { Page } from '@gauss/cms-shared';
async function fetchDynamicPageData(ctx) {
  const {
    params,
    route,
    req,
    $components,
    $api,
    error
  } = ctx;
  const res = await $components.fetchPageData({
    params
  });
  if (res.errored) {
    await $api.cms.redirect.addFailedRequest(route.path);
    return error(res);
  }
  let origin = null;

  // req is available only on server
  if (req) {
    origin = req.headers.origin || null;
  } else {
    origin = location.origin || null;
  }
  return {
    origin,
    pageData: res.data
  };
}
const PageDynamic = mixins(sectionView, PageWithSections, SeoHelper(true), WithRefs()).extend({
  name: Page.Post,
  layout: 'CmsMainLayout',
  components: {
    'admin-toolbar': () => import('../ui/AdminToolbar')
  },
  provide() {
    return {
      pageData: this.pageData
    };
  },
  async asyncData(ctx) {
    if (!ctx.$config.forceDomain && ctx.isDev) {
      ctx.redirect('/adminLogin');
      return;
    }
    return await fetchDynamicPageData(ctx);
  },
  created() {
    this.$nuxt.$on('refresh-page', this.refetchPageData);
    this.$nuxt.$on('getActivePageData', setPageData => setPageData(this.pageData));
  },
  mounted() {
    // Show toast if we successfully logged in with social login
    this.handleSuccessfulSocialLoginToast();
  },
  beforeDestroy() {
    this.$nuxt.$off('refresh-page');
    this.$nuxt.$off('getActivePageData');
  },
  methods: {
    handleSuccessfulSocialLoginToast() {
      if (this.$auth.loggedIn && this.$route.query.social) {
        this.$toast.success(this.$t('core.login.success'));
        this.$router.replace({
          query: this.$removeQueryParam('social')
        }).catch(() => {
          console.error(this.$t('error.redundantNavigationSkipped'));
        });
      }
    },
    async refetchPageData() {
      const {
        params
      } = this.$route;
      const res = await this.$components.fetchPageData({
        params
      });
      if (res.errored) {
        await this.$api.cms.redirect.addFailedRequest(this.$route.path);
        return;
      }
      this.$set(this, 'pageData', res.data);
    }
  },
  render() {
    var _this$pageData$compon;
    const h = arguments[0];
    return h("div", [h("client-only", [this.isBackofficeUser && !this.$route.query.mediaModal && this.pageData.display !== 'legacy' && h("admin-toolbar", _mergeJSXProps([{}, {
      "on": {
        'save-changes': this.saveChanges
      }
    }]))]), this.pageData.display === 'legacy' && h(PostView), (_this$pageData$compon = this.pageData.components) === null || _this$pageData$compon === void 0 ? void 0 : _this$pageData$compon.map((component, index) => {
      const Component = sectionMapper[component.handler];
      if (!Component) return this.$isInEditMode ? h("section", {
        "class": "bg-red-200 border-t border-dashed border-red-400 relative h-12 flex items-center justify-center"
      }, [h("div", {
        "class": "absolute top-0 left-0 px-3 py-1 text-white bg-red-600"
      }, [component.handler]), "Section not found."]) : undefined;
      return (// @ts-ignore
        h(Component, {
          "ref": "sections",
          "refInFor": true,
          "key": component.linkId,
          "attrs": {
            "componentData": component,
            "index": index
          }
        })
      );
    })]);
  }
});
export default PageDynamic;